const AUTH_MODAL = {
	SIGNUP: 'signupModal',
	LOGIN: 'loginModal',
	FORGOT_PASSWORD: 'forgotPassword'
};
export default AUTH_MODAL;
